import auth_config from '../../auth_config.json';

export const environment = {
  production: false,
  auth: {
    domain: auth_config.domain,
    clientId: auth_config.clientId,
    redirectUri: window.location.origin + '/matching',
    audience: auth_config.audience,
  },
  apiUrl: () => '/api/admin',
  // In dev we route through the Angular dev-server proxy (/e2e-api → https://e2e.recrewt.de/api)
  // to avoid CORS. In production the full URL is used directly.
  e2eApiUrl: '/e2e-api',
};
